const STORAGE_KEY = 'preformiq_welcome_tour';

function key(userId: string): string {
  return `${STORAGE_KEY}:${userId}`;
}

export function getWelcomeTourCompleted(userId: string | undefined): boolean {
  if (!userId) return true;
  try {
    return localStorage.getItem(key(userId)) === '1';
  } catch {
    return false;
  }
}

export function setWelcomeTourCompleted(userId: string): void {
  try {
    localStorage.setItem(key(userId), '1');
  } catch {
    /* ignore */
  }
}
